import React from 'react';
import TransactionsList from './TransactionsList';

const InTransactions: React.FC = () => (
  <TransactionsList
    type="in"
    title="In Transactions"
    description="All incoming transactions with search, currency and date filters"
  />
);

export default InTransactions;
